import type {
	BaseMetricDataWithStartAndStop,
	BasePageLoadMetricDataWithStartAndStop,
	PerformanceEventConfig,
} from '../../types';
import type { PageVisibleState } from '../../metric/base-metric';

export const pageVisibleState = (
	_config: PerformanceEventConfig,
	data: BaseMetricDataWithStartAndStop | BasePageLoadMetricDataWithStartAndStop,
): {
	'pageVisible:state': PageVisibleState;
} => {
	return {
		'pageVisible:state': data.pageVisibleState,
	};
};
